var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useRef } from 'react';
import { usePopoverState, Popover, PopoverDisclosure } from 'reakit';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import PopoverArrow from './ReakitOverrides/DejargonatorArrow';
import { Box } from '../Box';
import { TextHeadingDEPRECATED, TextBodyDEPRECATED, } from '../TypographyDEPRECATED';
import { calculateArrowOrientation, extractTranslationValues } from './utils';
if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
}
var DejargHeading = styled(TextHeadingDEPRECATED)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.theme, space = _b.space, colors = _b.colors, font = _b.font;
    return "\n    && {\n      color: ".concat(colors.white, ";\n      font-size: ").concat(font.body.sm.size, ";\n      line-height: ").concat(font.body.sm.lineHeight, ";\n      display: block;\n      \n      margin-bottom: ").concat(space.xs, ";\n\n      &:focus {\n        outline: none;\n      }\n    }\n  ");
});
var DejargBody = styled(TextBodyDEPRECATED)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.theme, colors = _b.colors, font = _b.font;
    return "\n  && {\n    color: ".concat(colors['gray-400'], ";\n    font-size: ").concat(font.body.sm.size, ";\n    line-height: ").concat(font.body.sm.lineHeight, ";\n\n    display: block;\n    white-space: pre-wrap;\n\n    &:focus {\n      outline: none;\n    }\n  }\n  ");
});
var StyledPopover = styled(Popover)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  && {\n    ", "\n\n  ", "\n"], ["\n  && {\n    ", "\n\n  ", "\n"])), function (_a) {
    var $placement = _a.$placement;
    switch ($placement) {
        case 'top':
            return 'margin-bottom: 5px;';
        case 'left':
            return 'margin-right: 10px;';
        case 'bottom':
            return 'margin-top: 5px;';
        case 'right':
            return 'margin-left: 10px;';
        default:
            return '';
    }
}, function (_a) {
    var _b = _a.theme, colors = _b.colors, media = _b.media, space = _b.space;
    return "\n        width: 100vw;\n        min-height: 50px;\n        padding: ".concat(space.none, ";\n        background: ").concat(colors.midnightblue, ";\n        border-radius: 4px;\n        color: ").concat(colors['slate-5'], ";\n        z-index: 5;\n        box-shadow: 0 4px 8px -2px rgba(0,0,0,0.16), 0 10px 12px -4px rgba(0,0,0,0.08);\n\n        ").concat(media.up('md'), " {\n          width: 360px;\n        }\n      }\n    }\n    ");
});
var StyledTrigger = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  && {\n    background: ", ";\n    cursor: help;\n  }\n"], ["\n  && {\n    background: ", ";\n    cursor: help;\n  }\n"])), function (_a) {
    var colors = _a.theme.colors, $highlightTrigger = _a.$highlightTrigger;
    return $highlightTrigger ? colors['gold-100'] : 'transparent';
});
var TriggerText = styled(TextBodyDEPRECATED)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  && {\n    display: inline-block;\n    padding: 0;\n    border: none;\n    border-bottom: ", ";\n    font-size: 14px;\n    font-family: ", ";\n  }\n"], ["\n  && {\n    display: inline-block;\n    padding: 0;\n    border: none;\n    border-bottom: ", ";\n    font-size: 14px;\n    font-family: ", ";\n  }\n"])), function (props) {
    return "1px dotted ".concat(props.theme.colors['slate-3']);
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.regular;
});
var IconWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  && {\n    display: inline-flex;\n  }\n"], ["\n  && {\n    display: inline-flex;\n  }\n"])));
var DejargContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  && {\n    display: inline-block;\n    line-height: 12px;\n  }\n"], ["\n  && {\n    display: inline-block;\n    line-height: 12px;\n  }\n"])));
var StyledPopoverDisclosure = styled(PopoverDisclosure)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  && {\n    min-width: auto;\n    border: none;\n    background: transparent;\n    padding: 0;\n  }\n"], ["\n  && {\n    min-width: auto;\n    border: none;\n    background: transparent;\n    padding: 0;\n  }\n"])));
var ExtraSpace = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n"])), function (_a) {
    var placement = _a.placement;
    if (placement === 'top') {
        return "\n        top: -25px;\n      ";
    }
    if (placement === 'left') {
        return "\n        top: -10px;\n        left: -30px;\n      ";
    }
    if (placement === 'right') {
        return "\n        top: -10px;\n        right: -30px;\n      ";
    }
    return '';
}, function (_a) {
    var placement = _a.placement;
    return "\n    width: ".concat(placement === 'top' || placement === 'bottom' ? '100%' : '30px', ";\n    height:").concat(placement === 'left' || placement === 'right' ? '50px' : '25px', ";\n    position: absolute;\n    cursor: default;\n  ");
});
var DisclosureWrapper = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"])));
var getTriggerElement = function (trigger) {
    switch (trigger.variant) {
        case 'text':
            return (React.createElement(TriggerText, { tag: "span", size: "sm" }, trigger.content));
        case 'icon':
            return (React.createElement(IconWrapper, { "data-testid": "trigger-icon" }, trigger.content));
        default:
            // default to returning the content directly - element variant handled here
            return trigger.content;
    }
};
var VisuallyHiddenP = styled.p(function (_a) {
    var screenReader = _a.theme.screenReader;
    return screenReader.srOnlyInline;
});
var VisuallyHiddenDescription = function (_a) {
    var descriptionUUID = _a.descriptionUUID;
    return (React.createElement(VisuallyHiddenP, { id: descriptionUUID, "aria-hidden": "true" }, "Select to learn more."));
};
var Dejargonator = function (_a) {
    var heading = _a.heading, body = _a.body, trigger = _a.trigger, popoverAriaLabel = _a.popoverAriaLabel, _b = _a.placement, placement = _b === void 0 ? 'bottom' : _b, popoverId = _a.popoverId, disabled = _a.disabled, _c = _a.isPopoverFixedPosition, isPopoverFixedPosition = _c === void 0 ? false : _c, headingTag = _a.headingTag, others = __rest(_a, ["heading", "body", "trigger", "popoverAriaLabel", "placement", "popoverId", "disabled", "isPopoverFixedPosition", "headingTag"]);
    var _d = __read(useState('left'), 2), arrowOrientation = _d[0], setArrowOrientation = _d[1];
    var popover = usePopoverState({
        placement: placement,
        baseId: popoverId,
        unstable_fixed: isPopoverFixedPosition,
    });
    var extraSpaceRef = React.createRef();
    var popoverRef = React.createRef();
    var descriptionUUID = React.useRef("dejarg-description-".concat(uuid())).current;
    /**
     * Don't show the popover until DOM updates are complete. This prevents the popover
     * from initially showing up in the wrong place while it waits to be repositioned by reakit.
     */
    var _e = __read(React.useState(false), 2), showPopover = _e[0], setShowPopover = _e[1];
    // unstable_arrowStyles is the last DOM update made to correctly position the popover
    useEffect(function () {
        setShowPopover(popover.visible);
    }, [popover, popover.unstable_arrowStyles]);
    /**
     * Some Android devices trigger 'mouseenter' on touch. isTouchEvent is used to disable the  'mouseenter'
     * handler in these cases to prevent users from having to click twice to open the dejarg
     */
    var _f = __read(useState(false), 2), isTouchEvent = _f[0], setIsTouchEvent = _f[1];
    useEffect(function () {
        popover.place(placement);
    }, [popover, placement]);
    var initialFocus = useRef(null);
    var triggerRef = useRef(null);
    var _g = __read(React.useState(false), 2), isBlurredOnTrigger = _g[0], setIsBlurredOnTrigger = _g[1];
    var handlePopoverBlur = function (e) {
        var isTrigger = e.relatedTarget === triggerRef.current;
        setIsBlurredOnTrigger(isTrigger);
        popover.hide();
    };
    var show = function () {
        if (!isTouchEvent && !disabled && !popover.visible) {
            popover.show();
            setIsBlurredOnTrigger(false);
        }
    };
    var hide = function () {
        if (popover.visible) {
            popover.hide();
            if (triggerRef.current) {
                triggerRef.current.focus();
            }
        }
    };
    useEffect(function () {
        var _a, _b, _c, _d;
        var arrowTranslationValues = extractTranslationValues(popover.unstable_arrowStyles.transform);
        var newArrowOrientation = calculateArrowOrientation(popover.placement, (_b = (_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0, (_d = (_c = popoverRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight) !== null && _d !== void 0 ? _d : 0, arrowTranslationValues);
        if (newArrowOrientation !== arrowOrientation) {
            setArrowOrientation(newArrowOrientation);
        }
    }, [popoverRef]);
    var onDejargElementMouseLeave = function (e) {
        var _a, _b;
        e.preventDefault();
        e.stopPropagation();
        // If the mouse enters an element that is not one of the related dejarg elements,
        // then we hide the dejarg. Otherwise it stays open while user moves the mouse
        // from the trigger to the dejarg, and vice versa.
        if (e.relatedTarget !== extraSpaceRef.current &&
            e.relatedTarget !== ((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.children[0].children[0]) &&
            e.relatedTarget !== ((_b = popoverRef.current) === null || _b === void 0 ? void 0 : _b.children[1])) {
            hide();
        }
    };
    var handleTriggerOnClick = function (e) {
        setIsTouchEvent(false);
        var isNonClickEvent = e.detail === 0;
        if (isBlurredOnTrigger && !isNonClickEvent)
            e.preventDefault();
        setIsBlurredOnTrigger(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DejargContainer, null,
            React.createElement(DisclosureWrapper, null,
                React.createElement(StyledPopoverDisclosure, __assign({}, popover, { ref: triggerRef, onTouchStart: function () { return setIsTouchEvent(true); }, onMouseEnter: show, onMouseLeave: onDejargElementMouseLeave, onClick: handleTriggerOnClick, "data-testid": "trigger-button", "aria-label": trigger.ariaLabel, "aria-describedby": descriptionUUID, disabled: disabled, focusable: !disabled }),
                    React.createElement(StyledTrigger, { "data-testid": "mui-dejargonator-trigger", "$highlightTrigger": popover.visible &&
                            trigger.variant !== 'icon' &&
                            !trigger.disableTriggerHighlight }, getTriggerElement(trigger))),
                React.createElement(ExtraSpace, { ref: extraSpaceRef, placement: placement, onMouseLeave: onDejargElementMouseLeave })),
            React.createElement(StyledPopover, __assign({ role: "region", ref: popoverRef }, popover, { "aria-label": popoverAriaLabel, hideOnEsc: true, hideOnClickOutside: true, onMouseLeave: onDejargElementMouseLeave, unstable_initialFocusRef: initialFocus, onBlur: handlePopoverBlur, "data-testid": "dejarg-content-wrapper", "$placement": popover.placement }, (!showPopover && { style: { opacity: 0 } }), others),
                React.createElement(PopoverArrow, __assign({}, popover, { orientation: arrowOrientation })),
                React.createElement(Box, { position: "relative", p: "md" },
                    !!heading && (React.createElement(DejargHeading, { ref: initialFocus, tag: headingTag || 'h1', size: "sm", fontWeight: "bold", tabIndex: -1, "data-testid": "dejarg-header" }, heading)),
                    React.createElement(DejargBody, __assign({ tag: "span", size: "sm", "data-testid": "dejarg-content" }, (heading ? {} : { ref: initialFocus, tabIndex: -1 })), body)))),
        React.createElement(VisuallyHiddenDescription, { descriptionUUID: descriptionUUID })));
};
export { Dejargonator };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=Dejargonator.js.map